export default __webpack_public_path__ + "static/media/28.34fdf780.jpg";